import { useMutation } from "@tanstack/react-query";
import { WebhookService } from "../../../services/api";
import FormTemplate from "../../templates/FormTemplate";
import { Stack } from "@mui/material";
import FormInput from "../../molecules/FormInput";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export default function CreateWebhookForm() {
  const { t } = useTranslation("WebhookForm");
  const navigate = useNavigate();

  const [description, setDescription] = useState("");
  const [url, setUrl] = useState("");

  const { mutate: createWebhook, isPending: isCreating } = useMutation({
    mutationFn: async () => {
      const res = await WebhookService.createWebhook({
        createWebhookBody: {
          description,
          url,
          enabled: true,
          events: [],
          headers: [],
        },
      });
      return res.data.data;
    },
    onSuccess: (data) => {
      if (data) navigate(`/m/settings/integrations/webhooks/${data._id}`);
    },
  });

  return (
    <FormTemplate
      title={t("CreateWebhook")}
      onSubmit={() => createWebhook()}
      disableHeaderCloseButton
      loading={isCreating}
    >
      <Stack spacing={2}>
        <FormInput
          required
          label={t("Description")}
          field="description"
          placeholder={t("DescriptionPlaceholder")}
          value={description}
          onChange={(v) => setDescription(v as string)}
          type="string"
          loading={isCreating}
        />
        <FormInput
          required
          label={t("Url")}
          field="url"
          placeholder={t("UrlPlaceholder")}
          value={url}
          onChange={(v) => setUrl(v as string)}
          type="string"
          loading={isCreating}
        />
      </Stack>
    </FormTemplate>
  );
}
